__turbopack_context__.v({
  "ant-theme-dark": "default-button-module__FzT7uG__ant-theme-dark",
  "defaultButton": "default-button-module__FzT7uG__defaultButton",
  "primaryButton": "default-button-module__FzT7uG__primaryButton",
  "secondaryButton": "default-button-module__FzT7uG__secondaryButton",
  "secondaryRedButton": "default-button-module__FzT7uG__secondaryRedButton",
});
